// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__12V29","selects":"Documents_selects__2A6tA"};